import React, { PureComponent } from 'react';
import axios from 'axios';

import { historyService, history } from '../../../../services/history';
import { fetchOfferList, debounce } from '../../../../services/services';
import Loader from './components/loader';
import Hints from './components/hints';
import OfferWithHotelList from './components/with-hotel/index';
import Flight from './components/flight/index';
import GroupReservation from './components/group-reservation/index';
import NoOffersContactForm from '../../../../common/components/no-offers-contact-form';
import { T } from '../../../../../../common/locale/translate';
import { updateAnalyticsConfiguration } from '../../../../services/analytics';

export default class OffersList extends PureComponent {
  constructor() {
    super();
    this.state = {
      unlisten: () => {},
      offer_types: {
        C1: { genre: 'flight', name: T('flight_tickets') },
        C2: { genre: 'flight', name: T('flight_tickets') },
        S: { genre: 'withHotel', name: T('hotels') },
        A: { genre: 'withHotel', name: T('holiday') },
        GROUP: { genre: 'groupReservation', name: T('group_reservation') },
        NoData: { genre: 'NoData', name: T('no_offers') },
        Error: { genre: 'Error', name: T('system_error') }
      },
      current_offer: '',
      current_offer_type: '',
      action_states: { pristine: true, in_progress: false, available: false },
      current_state: 'pristine',
      current_page: 0,
      content_header: T('found_offers'),
      is_last_page: false,
      loader: true,
      params: {},
      data: [],
      preloadPoint: 4, //in range 0 - max per page
      scroll_debounce: 150, //in milliseconds
      axios_source: null
    };

    this.handleDebouncedScroll = debounce(function() {
      this.handleScroll.apply(this);
    }, this.state.scroll_debounce);
  }

  componentDidMount() {
    document.addEventListener(
      'scroll',
      this.handleDebouncedScroll.bind(this),
      true
    );
    if (typeof history() == 'undefined') {
      historyService.createComponentHistory();
    }
    const unlisten = historyService.listener(this.handleHistoryChange);
    const params = this.props.params;
    this.setState({ unlisten, params });
    this.setOfferList(params);
  }

  componentWillUnmount() {
    this.state.unlisten();
    document.removeEventListener(
      'scroll',
      this.handleDebouncedScroll.bind(this),
      true
    );
  }

  render = () => {
    const { are_hints_visible, curiosities, seo_params, regions } = this.props;
    const { current_state, loader, is_last_page } = this.state;
    return (
      <div className="content-wrapper">
        {are_hints_visible && !this.isNoOffersOrErrored() ? (
          <Hints
            regions={regions}
            curiosities={curiosities}
            seoDescription={seo_params.description}
            isSeo={seo_params.is_seo}
          />
        ) : (
          false
        )}
        {this.isGroupReservation() ? (
          <GroupReservation />
        ) : (
          [
            this.searchedElements(),
            <Loader active={loader} className="general-content-loader" />,
            <div
              className={`button-wrapper ${
                current_state !== 'pristine' && !loader && !is_last_page
                  ? 'visible'
                  : 'invisible'
              }`}
            >
              <button
                className="load-more"
                onClick={this.handleClick}
                id="loadmore"
              >
                {T('offers_collection_load_more_offers')}
              </button>
            </div>
          ]
        )}
      </div>
    );
  };

  handleScroll() {
    let loadpoints = document.querySelectorAll('.preload-offers'),
      minor = window.innerHeight,
      itemsCounter = 0,
      that = this;

    [].forEach.call(loadpoints, function(item, index) {
      let offset = item.getBoundingClientRect();
      itemsCounter = index;
      let is_in_viewport = offset.top < minor && offset.top > 0,
        append_data =
          that.state.current_state !== 'in-progress' &&
          itemsCounter == that.state.current_page;
      if (is_in_viewport && append_data) {
        let params = that.state.params;
        params.page = that.state.current_page + 1;
        that.setOfferList(params, true);
      }
    });
  }

  handleHistoryChange = (location, params) => {
    updateAnalyticsConfiguration(location.pathname, location.search);

    params = params['offer_type'] ? params : this.props.params;
    this.setState({ seo_title: false });
    this.setOfferList(params);
  };

  handleClick = () => {
    let params = this.state.params;
    params.page = this.state.current_page + 1;
    this.setOfferList(params, true);
  };

  setOfferList = (params, append) => {
    // cancel previous request
    let CancelToken = axios.CancelToken;
    let source = CancelToken.source();
    if (this.state.axios_source === null) {
      this.setState({ axios_source: source });
    } else {
      this.state.axios_source.cancel();
    }

    const offerType =
      params['offer_type'] && params['offer_type'].toUpperCase
        ? params['offer_type'].toUpperCase()
        : params['offer_type'];

    if (offerType == 'GROUP') {
      return this.setState({
        loader: false,
        current_offer_type: offerType
      });
    }

    const chosen_action = this.state.offer_types[offerType];
    if (params.page == undefined || params.page == null) {
      params.page = this.state.current_page;
    }
    if (append == undefined || append == false) {
      params.page = 0;
    }

    this.setState(
      {
        loader: true,
        current_state: 'in-progress',
        current_offer: chosen_action.name,
        current_offer_type: offerType,
        params,
        data: append ? this.state.data : []
      },
      () => {
        fetchOfferList(params, source.token).then(
          response => {
            this.props.getBreadcrumbsList(response.data.schema_breadcrumb);

            if (response.status == 204) {
              this.setState({ loader: false }, () => {
                setTimeout(() => {
                  this.setState({
                    current_offer_type: append
                      ? this.state.current_offer_type
                      : 'NoData',
                    current_state: 'pristine',
                    is_last_page: true,
                    axios_source: null
                  });
                }, 150);
              });
            } else {
              this.setState({ loader: false }, () => {
                setTimeout(() => {
                  this.setState({
                    data: this.state.data.concat(response.data.offers_list),
                    current_state: 'data-loaded',
                    current_page: append ? ++this.state.current_page : 0,
                    is_last_page: response.data.is_last_page,
                    axios_source: null
                  });
                }, 150);
              });
            }
          },
          error => {
            if (axios.isCancel(error)) {
              console.log('OfferList - Request canceled');
            } else {
              // TODO handle error
              this.setState({ loader: false }, () => {
                setTimeout(() => {
                  this.setState({
                    current_offer_type: 'Error',
                    current_state: 'pristine',
                    is_last_page: true
                  });
                }, 150);
              });
            }
          }
        );
      }
    );
  };

  searchedElements = () => {
    const genre = this.state.offer_types[this.state.current_offer_type]
      ? this.state.offer_types[this.state.current_offer_type].genre
      : '';
    const actions = {
      flight: this.returnOfferFlight,
      withHotel: this.returnOfferWithHotel,
      NoData: this.returnNoDataElement,
      Error: this.returnErrorElement
    };
    return actions[genre] ? actions[genre]() : '';
  };

  returnOfferWithHotel = () => (
    <OfferWithHotelList
      offer_type={this.state.current_offer_type}
      data={this.state.data}
      params={this.state.params}
      preloadPoint={this.state.preloadPoint}
    />
  );

  returnOfferFlight = () => (
    <Flight
      offer_type={this.state.current_offer_type}
      data={this.state.data}
      params={this.state.params}
    />
  );

  returnNoDataElement = () => {
    return (
      <div>
        <div className="no-offer-information">
          <figure>
            <img src="/img/luggage.png" alt="" />
            <figcaption>
              <h4>{T('no_offers_found')}</h4>
              <p
                className="no-offers-description"
                dangerouslySetInnerHTML={{ __html: T('dont_be_worried') }}
              />
            </figcaption>
          </figure>
        </div>

        <NoOffersContactForm
          className="empty-offers-list-contact-form"
          header={T('no_offers_contact_form_header')}
          sendButtonText={T('no_offers_contact_form_button')}
        />
      </div>
    );
  };

  returnErrorElement = () => (
    <div>
      <div className="no-offer-information error">
        <figure>
          <img src="/img/luggage.png" alt="" />
          <figcaption>
            <h4>{T('offers_list_error')}</h4>
            <h5 className="no-offers-description">{T('refresh_page')}</h5>
          </figcaption>
        </figure>
      </div>
      <NoOffersContactForm
        className="empty-offers-list-contact-form"
        header={T('no_offers_contact_form_header')}
        sendButtonText={T('no_offers_contact_form_button')}
      />
    </div>
  );

  isGroupReservation = () => this.state.current_offer_type === 'GROUP';

  isNoOffersOrErrored = () =>
    this.state.current_offer_type === 'NoData' ||
    this.state.current_offer_type === 'Error';
}



// WEBPACK FOOTER //
// ./app/javascript/pages/offers/components/offers_list/index.js